var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoDashboardFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 26,
    width: 218,
    height: 250,
    rx: 30
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 26,
    width: 218,
    height: 250,
    rx: 30,
    fill: "white",
    stroke: "white",
    strokeWidth: 80,
    mask: "url(#path-1-inside-1_2_2)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_2_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277,
    y: 224,
    width: 218,
    height: 250,
    rx: 30
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 277,
    y: 224,
    width: 218,
    height: 250,
    rx: 30,
    fill: "white",
    stroke: "white",
    strokeWidth: 80,
    mask: "url(#path-2-inside-2_2_2)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_2_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277,
    y: 26,
    width: 218,
    height: 150,
    rx: 30
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 277,
    y: 26,
    width: 218,
    height: 150,
    rx: 30,
    fill: "white",
    stroke: "white",
    strokeWidth: 80,
    mask: "url(#path-3-inside-3_2_2)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_2_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 324,
    width: 218,
    height: 150,
    rx: 30
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 324,
    width: 218,
    height: 150,
    rx: 30,
    fill: "white",
    stroke: "white",
    strokeWidth: 80,
    mask: "url(#path-4-inside-4_2_2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDashboardFill);
export default __webpack_public_path__ + "static/media/ico_dashboard_fill.cf77487ca06793ef7a55433a3fa08a93.svg";
export { ForwardRef as ReactComponent };